import { AccountBillingInformation } from 'protocol/api/billing/dto_account_pb';

import { BILLING_ZONE_WITHOUT_STRIPE_REGEXP } from '../config/constants';

export const shouldAskAdditionalInfo = (geoZone: string, billingInformation: AccountBillingInformation): boolean => !BILLING_ZONE_WITHOUT_STRIPE_REGEXP.test(geoZone) &&
  (!billingInformation?.Address?.Address ||
    !billingInformation?.Phone ||
    !billingInformation?.CompanyName ||
    !billingInformation?.TaxID);
